import * as React from "react";

import { GenomicVariant } from "../../api";

interface Props {
  genomeLength: number;
  windowWidthPercentage: number;
  windowBeginsPercentage: number;
  contigPositions: number[];
  jumpToPosition: (offsetX: number, genomeLength: number) => void;
  jumpToVariant: (variant: GenomicVariant) => void;
}

export function ViralTrackScrubber(props: Props) {
  function renderContigDividers() {
    const dividers = [];
    let runningSum = 0;
    for (let i = 0; i < props.contigPositions.length; i++) {
      runningSum += props.contigPositions[i];
      dividers.push(
        <div
          key={"divider-" + i}
          className="annotation-track-scrubber__contig-divider"
          style={{
            left: (runningSum / props.genomeLength) * 100 + "%",
          }}
        />
      );
    }
    return dividers;
  }

  function jumpTrackToCursor(e: React.MouseEvent) {
    props.jumpToPosition(e.nativeEvent.offsetX, props.genomeLength);
  }

  return (
    <>
      <div className="annotation-track-scrubber" onClick={jumpTrackToCursor} />

      <div
        className="annotation-track-scrubber__window"
        style={{
          left: props.windowBeginsPercentage + "%",
          width: props.windowWidthPercentage + "%",
        }}
      />
      {renderContigDividers()}
    </>
  );
}
